export default "__VITE_ASSET__DoEQFjKD__"